var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organsim-title-and-description"},[_c('MoleculesCommonMoleculeTitleAndDescription',_vm._l((_vm.visionData),function(vision,index){return _c('AtomsCommonAtomTitleAndDescription',{key:index,attrs:{"title":_vm.$tdb(vision.title),"description":_vm.$tdb(vision.description)}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }